import { es, enUS } from "date-fns/locale";
import { DatePickerLocaleMap } from "./DatePickerCalendar.types";

export const DATE_PICKER_CALENDAR_LOCALES: DatePickerLocaleMap = {
    es: es,
    en: enUS,
};
